import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getEligibleSuppliers } from 'api/referenceAPI';
import { handleError } from 'services/Error';
import { fetchPlacesOfService, fetchSupplierDetails } from 'store/referralForm/referenceSlice';

export const useSupplierDetails = (supplierNpi) => {
    const supplierDetails = useSelector((state) => state.reference.supplierDetails[supplierNpi]);
    const dispatch = useDispatch();
    useEffect(() => {
        if (supplierNpi && !supplierDetails) {
            dispatch(fetchSupplierDetails(supplierNpi));
        }
    }, [supplierNpi, supplierDetails, dispatch]);
    return supplierDetails;
};

export const useEligibleSuppliers = ({
    payerId,
    segmentId,
    memberState,
    productServiceOid,
    benefit,
    placeOfService,
    fetchValues = true,
}) => {
    const [eligibleSuppliers, setEligibleSuppliers] = useState();
    useEffect(() => {
        (async () => {
            if (
                payerId &&
                segmentId &&
                memberState &&
                productServiceOid &&
                benefit &&
                placeOfService &&
                fetchValues
            ) {
                try {
                    const response = await getEligibleSuppliers({
                        payerId,
                        segmentId,
                        memberState,
                        productServiceOid,
                        placeOfService,
                        benefit,
                    });
                    setEligibleSuppliers(
                        response?.map((supplier) => ({
                            npi: supplier.npi,
                            name: supplier.organization_name,
                        })) ?? [],
                    );
                } catch (err) {
                    setEligibleSuppliers([]);
                    handleError(
                        'An error occurred retrieving authorized pharmacy information.',
                        err,
                    );
                }
            }
        })();
    }, [payerId, segmentId, memberState, productServiceOid, benefit, placeOfService, fetchValues]);
    return eligibleSuppliers;
};

export const usePlaceOfServiceList = () => {
    const placeOfServiceList = useSelector((state) => state.reference.placeOfServiceList);
    const dispatch = useDispatch();
    useEffect(() => {
        if (!placeOfServiceList) {
            dispatch(fetchPlacesOfService());
        }
    }, [placeOfServiceList, dispatch]);
    return placeOfServiceList;
};
